import { app } from '../../../../../../../bootstrap/core';

import { createRequestRBAustriaComponent } from './rbAustria.component';

app.component(
  createRequestRBAustriaComponent.name,
  createRequestRBAustriaComponent,
);
